import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class StatsService {
  totalLength = 0;
  hmoNotAssign =[]
  statsForm;
  usersStats = [];
  users =[];
  HMO = ['Macabi', 'Leumit', 'Meuhedet', 'Clalit', 'Private' ]
  code;
  Params;
  isGastro;
  isCardio;
  examsArray = [];
  clinicGroups: string[] = [];
  statsLoaded$ = new Subject<void>();
  CARDIO = ['TTE Adults', 'Stress', 'Stress-Echo','Duplex Carotid', 'All']
  GASTRO = ["Gastroscopy", "Colonoscopy", "Sigmoidoscopy", "Hemorrhoids Treatment", "All"];
  USG = ["Abdomen US", "MSK Musculoskeletal", "MSK & Soft Tissues", "Neck scan", "Ultrasound Scan Summary", "Endoscopy", "Consultation Letter", "Clinics", "consultation and follow up with media", "All"];
  GASTROFORMS=[ 'Admission', 'TimeOut', 'AllForms']
  GYN =[ '1st', 'NT', 'Early', '2nd/3rd','Weight Assessment','Tech Exam', 'Late', 'Specialized' ,'Fetal Echo', 'Gynecology', 'Follicles', 'CVS', 'Amniocentesis','Emergency Room', 'All'];
  INVASIVE =[  'CVS', 'Amniocentesis',  'AllInvasive']
  constructor(private http:HttpClient, private fb: UntypedFormBuilder, private ls:LoginService) { 
    this.resetForm();
    
  }
  resetForm(){
    this.statsForm = this.fb.group({
      AbdomenUS:[''],
      MSKMusculoskeletal:[''],
      UltrasoundScanSummary:[''],
      ConsultationLetter:[''],
      consultationandfollowupwithmedia:[''],
      Gastroscopy:[''],
      Colonoscopy:[''],
      Sigmoidoscopy:[''],
      Gynecology :[''],
      CVS :[''],
      Amniocentesis :[''],
      Follicles:[''],
      first:[''],
      NT:[''],
      Early:[''],
      second:[''],
      WeightAssessment:[''],
      TechExam:[''],
      Late:[''],
      Specialized:[''],
      FetalEcho:[''],
      All:[''],
      start:[''],
      end:[''],
      exams:[''],
      Admission:[''],
      TimeOut:[''],
      AllForms:[''],
      examsUsers:[''],
      formsUsers:[''],
      TTEAdults:[''],
      Stress:[''],
      DuplexCarotid:[''],
      StressEcho:[''],
      EmergencyRoom:[''],
      HemorrhoidsTreatment:[''],
      
    })
  }

  search(params, code=null){
    if(code){
      this.code = code;
      this.loadData(code)
    }
    this.Params = params;
    // this.Params['isUSG'] = this.ls.isUSG
    this.http.get('/api/stats', {'params':params}).subscribe((data) => {
      this.resetForm();
      if(params.end && params.start){
        this.statsForm.get('start').setValue(params.start)
        this.statsForm.get('end').setValue(params.end)
      }else{
        this.statsForm.patchValue(data)
      }
      // this.isUSG = data['isUSG'];
      if(data['type'] =='CARDIO'){
        this.ls.isCardio = true;
        this.ls.isUSG = false;
        this.examsArray = this.CARDIO;
      }
      else if(data['type'] =='GASTRO'){
        this.ls.isUSG = false;
        this.ls.isCardio = false;
        this.examsArray = this.GASTRO;
      }else if(data['type'] =='USG'){
        this.ls.isUSG = true;
        this.ls.isCardio = false;
        this.examsArray = this.USG;
      }else{
        this.ls.isUSG = false;
        this.ls.isCardio = false;
        this.examsArray = this.GYN;
      }
      this.filterData(data);
      this.statsLoaded$.next()
    })
    
  }
  filterByHMO(data,hmo){
    if(!data)
      return []
    var temp = data;
    this.hmoNotAssign = temp.filter((i) => i.HMO ==null)
    return temp.filter((i) => i.HMO ==hmo)
    // if(temp.length > 0 ){
    // }
    // return temp
    
  }

  filterData(data){
    this.usersStats = data['data'];
    this.clinicGroups = [];
      let name
      if(data['All']){
        var exams = data['All'];
        this.totalLength = exams.length;
        this.statsForm.get('All').setValue(exams);
        let examArray = this.ls.isUSG ? this.USG : (this.ls.isCardio ? this.CARDIO : this.GASTRO);
        for(let i=0; i<examArray.filter((i)=> i !='All').length; i++){
          name = examArray[i].replace(/ /g, '');
          this.statsForm.get(name)?.setValue(exams.filter((exam) => exam.ExamType == examArray[i]))
        }
        if(this.ls.isUSG){
          this.clinicGroups = this.buildClinicGroups(exams);
          this.examsArray = this.buildUsgArray();
        }
        
      }
      if(data['AllForms']){
        this.statsForm.get('AllForms').setValue(data['AllForms']);
        this.statsForm.get('Admission').setValue(data['All'].filter((i) => i.FormName =='Admission Form'))
        this.statsForm.get('TimeOut').setValue(data['All'].filter((i) => i.FormName =='Time Out Form'))
      }
      return;
    
    
  }
  statsGroup(exam){
    if(!exam || exam.ExamType != 'Clinics')
      return exam ? exam.ExamType : null;
    let group = exam.StatsGroup || 'Clinics';
    if(group != 'Clinics' && this.USG.includes(group))
      group += ' (Clinics)';
    return group;
  }

  buildClinicGroups(exams){
    let groups = [];
    for(let exam of exams || []){
      if(exam.ExamType != 'Clinics')
        continue;
      let group = this.statsGroup(exam);
      if(!groups.includes(group))
        groups.push(group);
    }
    return groups.sort((a, b) => a.localeCompare(b));
  }

  buildUsgArray(){
    let groups = this.clinicGroups.length ? this.clinicGroups : ['Clinics'];
    let result = [];
    for(let type of this.USG){
      if(type == 'Clinics')
        result.push(...groups);
      else
        result.push(type);
    }
    return result;
  }

  isClinicGroup(name){
    return this.clinicGroups.includes(name);
  }

  examsOfGroup(exams, name){
    if(!exams)
      return [];
    return exams.filter((exam) => this.statsGroup(exam) == name);
  }

  loadData(code){
    this.code = code;
    this.http.post('/api/print/resurection', {code:code}).subscribe((data) => {
      this.search(this.Params);
    })
  }

}
